import { Button, Col, Form, message, Row, Spin } from "antd";
import { FC, useContext, useEffect, useState } from "react";
import {
  AmountBreakdown,
  CreateDrawRequest,
  CreateDrawRequestPayment,
  DrawRequest,
  DrawRequestPreviewInterface,
  DrawRequestResp,
  PaymentPreviewInterface
} from "../../../../types/draw-request";
import { FirstForm } from "../FirstForm/FirstForm";
import { SecondForm } from "../SecondForm/SecondForm";
import { SignatureModal } from "../../../../components/SignatureModal/SignatureModal";
import { drawRequestsService } from "../../../../services/draw-request";
import { useLocation, useNavigate, useParams } from "react-router";
import { DataContext } from "../../../../contexts/DataContext";
import moment from "moment";
import { ApproverResponse } from "../../../../types/approvers";
import { DrawRequestPreview } from "../DrawRequestPreview/DrawRequestPreview";
import { turnDate } from "../../../../helpers";
import { useMsal } from "@azure/msal-react";

interface Props {}

/**========================================================================
 *                           external const here
 *========================================================================**/
let payloadExternal: any = {};
/*============================ END OF SECTION ============================*/

/**========================================================================
 *                           external methods here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

export const DrawRequestNewModal: FC<Props> = () => {
  /**========================================================================
   *                           Hooks here
   *========================================================================**/

  const { accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();

  const accountName = accounts && accounts.length ? accounts[0].name : "";

  const { id } = useParams();
  const [amounts, setAmounts] = useState<AmountBreakdown[]>([
    { id: 1, name: "", relatedLocation: "", amount: 0, salesTax: 0, glCodeID: undefined }
  ]);
  const [approvers, setApprovers] = useState<ApproverResponse[]>([
    { email: "", hasApproved: null, role: "approver", sortOrder: 1, userID: undefined, id: 1 }
  ]);

  const [isCopy, setIsCopy] = useState<boolean>(false);

  const [isDistribution, setIsDistribution] = useState<boolean>(false);
  // useEffect(() => {
  //   if (id) setEdit(id);
  // }, [id, isCopy]);

  useEffect(() => {
    const { pathname } = location;
    if (pathname.toLowerCase().includes("copy-draw-request")) {
      setIsCopy(true);
    }
    if (id) setEdit(id);
  }, [location]);

  const {
    drawRequestContext: {
      drawRequestData: { approvers: approversData, expatOfficers }
    },
    projects,
    signatureContext: { setSignature, signature }
  } = useContext(DataContext);

  const [form1] = Form.useForm<CreateDrawRequest>();
  const [form2] = Form.useForm<CreateDrawRequestPayment>();
  const [createdDrawRequest, setCreatedDrawRequest] = useState<DrawRequest | undefined>(undefined);
  const [createdDrawRequestId, setCreatedDrawRequestId] = useState<number | undefined>(undefined);

  const [step, setStep] = useState<1 | 2 | 3>(1);
  const [drawRequestState, setDrawRequestState] = useState<DrawRequestResp | undefined>(undefined);
  const [signatureModal, setSignatureModal] = useState<boolean>(false);
  const [finalPayload, setFinalPayload] = useState<any>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [drawRequestPreview, setDrawRequestPreview] = useState<DrawRequestPreviewInterface | undefined>(undefined);
  const [paymentPreview, setPaymentPreview] = useState<PaymentPreviewInterface | undefined>(undefined);

  /*============================ END OF SECTION ============================*/
  /**========================================================================
   *                           Const here
   *========================================================================**/

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Methods here
   *========================================================================**/

  /**============================================
  //?  Setting edit draw request 
   *=============================================**/

  const getControlNumber = (cnArray: string[]) => {
    let cn = `${id}-0`;
    if (cnArray.length !== 2) return cn;
    const incremental = Number(cnArray[1]);
    if (!incremental && incremental !== 0) return cn;
    cn = `${cnArray[0]}-${incremental + 1}`;
    return cn;
  };

  const setEdit = async (id: number | string) => {
    setIsEdit(true);
    setIsLoading(true);
    try {
      const drawRequest: DrawRequestResp = await drawRequestsService.getDrawRequestById(id);

      if (!drawRequest) throw new Error("not draw request found");

      setDrawRequestState(drawRequest);
      //first form values
      // const form1Values = {
      //   paymentMethod: drawRequest.paymentMethod?.id,
      //   initiator: drawRequest.initiator || "",
      //   projectID: drawRequest.projectID,
      //   drawNumber: drawRequest.drawNumber || "",
      //   amount: drawRequest.amount || 0,
      //   dueDate: moment(drawRequest.dueDate) || moment(),
      //   MainCmsGlCodeID: drawRequest.mainCmsGlCodeID,
      //   JvDepositGlCodeID: drawRequest.jvDepositGlCodeID,
      //   JvWithdrawalGlCodeID: drawRequest.jvWithdrawalGlCodeID,
      //   drawType: drawRequest.drawType,
      //   invoiceDate: drawRequest.invoiceDate
      // };

      setIsDistribution(drawRequest.drawType === "distribution");
      const { pathname } = location;
      const isCopy = pathname.toLowerCase().includes("copy-draw-request") || false;

      let controlNumber = "0";
      if (!isCopy) controlNumber = drawRequest.controlNumber;
      else {
        const cnAUx =
          !drawRequest.controlNumber || drawRequest.controlNumber == "0" ? [`${id}`, "0"] : drawRequest.controlNumber?.split("-");

        controlNumber = getControlNumber(cnAUx);
      }

      form1.setFieldsValue({
        paymentMethod: drawRequest.paymentMethod?.id,
        initiator: drawRequest.initiator || "",
        projectID: drawRequest.projectID,
        drawNumber: drawRequest.drawNumber || "",
        amount: drawRequest.amount || 0,
        dueDate: moment(drawRequest.dueDate) || moment(),
        MainCmsGlCodeID: drawRequest.mainCmsGlCodeID,
        JvDepositGlCodeID: drawRequest.jvDepositGlCodeID,
        JvWithdrawalGlCodeID: drawRequest.jvWithdrawalGlCodeID,
        drawType: drawRequest.drawType,
        invoiceDate: drawRequest.invoiceDate ? moment(drawRequest.invoiceDate) : undefined,
        controlNumber
      });

      //second from values
      form2.setFieldsValue({
        sanctionNo: drawRequest?.paymentForm?.sanctionNo || "",
        payee: drawRequest?.paymentForm?.payee || "",
        isNewPayee: drawRequest?.paymentForm?.isNewPayee || false,
        vendorCode: drawRequest?.paymentForm?.vendorCode || "",
        address: drawRequest?.paymentForm?.address || "",
        address2: drawRequest?.paymentForm?.address2 || "",
        specify: drawRequest?.paymentForm?.specify || "",
        chargeTo: drawRequest?.paymentForm?.chargeTo || "",
        abbaOrSwiftAccountNo: drawRequest?.paymentForm?.abbaOrSwiftAccountNo || "",
        accountNo: drawRequest?.paymentForm?.accountNo || "",
        expatInChargeId: drawRequest?.paymentForm?.expatInChargeId,
        expatOfficerId: drawRequest?.paymentForm?.expatOfficerId,
        agreementPath: drawRequest?.paymentForm?.agreementPath || "",
        bankName: drawRequest?.paymentForm?.bankName || "",
        isGASanction: drawRequest?.paymentForm?.isGASanction || false,
        debitBlockID: drawRequest?.paymentForm?.debitBlockID || ""
        // relatedLocation: drawRequest?.paymentForm?.relatedLocation
      });

      //fixing amountBreaks
      const amountBreaks: AmountBreakdown[] = drawRequest.amountBreakdowns || [];
      fixAmountBreak(amountBreaks);
      //fixing approvers
      const newApprovers: ApproverResponse[] = drawRequest.approvers || [];
      fixApprovers(newApprovers);
    } catch (error) {
      console.error(error);
      message.error("Ups: something was wrong editing the draw request, please try again later or contact the support");
      navigate("/draw-requests");
    }

    setIsLoading(false);
  };
  //      labelAmount${number}
  // valueAmount${number}
  // glCodeAmount${number}

  const fixAmountBreak = (amountBreaks: AmountBreakdown[]) => {
    if (!amountBreaks.length) return;
    (amountBreaks || []).forEach((amountBreak) => {
      const amount = {
        [`labelAmount${amountBreak.id}`]: amountBreak.name,
        [`valueAmount${amountBreak.id}`]: amountBreak.amount,
        [`salesTax${amountBreak.id}`]: amountBreak.salesTax,
        [`glCodeAmount${amountBreak.id}`]: amountBreak.glCodeID,
        [`relatedLocation${amountBreak.id}`]: amountBreak.relatedLocation
      } as Partial<CreateDrawRequestPayment>;
      form2.setFieldsValue({
        ...amount
      });
    });

    setAmounts(amountBreaks);
  };
  const fixApprovers = (newApprovers: ApproverResponse[]) => {
    if (!newApprovers.length) return;

    (newApprovers || []).forEach((appAux) => {
      const ap = {
        [`approver${appAux.userID}`]: appAux.userID
      } as Partial<CreateDrawRequestPayment>;

      form2.setFieldsValue({
        ...ap
      });

      setApprovers([...newApprovers.map((ap) => ({ ...ap, id: ap.userID as number }))]);
    });
  };
  /*=============== END OF ee ==============*/

  const handleCancel = () => {
    navigate("/draw-requests");
  };

  const onSubmitSignature = async (signature: string) => {
    setIsLoading(true);
    setSignature(signature);
    await onCreateAllDrawRequest(true);
    setIsLoading(false);
  };

  const onCreateAllDrawRequest = async (isCreate: boolean) => {
    const payload = { ...payloadExternal };

    if (payload?.paymentForm) {
      if (typeof payload.paymentForm === "string") {
        const pf: any = JSON.parse(payload.paymentForm);
        pf.paymentForm.initiatorSignature = signature;
        payload.paymentForm = JSON.stringify(pf);
      } else payload.paymentForm.initiatorSignature = signature;
    }

    if (!createdDrawRequest) return;

    payload.drawRequest = createdDrawRequest.id;

    if (!isCreate && payload.paymentForm) payload.paymentForm.initiatorSignature = "";

    payload.paymentForm = JSON.stringify({ ...payload.paymentForm });
    setFinalPayload(payload);
    payloadExternal = payload;

    try {
      const data = {
        agreementDocID: payload.agreementDoc,
        invoiceCapitalCallDoc: payload.invoiceCapitalCallDoc,
        sanctionDoc: payload.sanctionDoc,
        achWireInstructions: payload.achWireInstructions,
        w9Form: payload.w9Form
      };

      if (!isEdit || isCopy) {
        await drawRequestsService.createDrawRequestNew(isCreate, payload.drawRequest, payload.paymentForm, data);

        message.success(`Draw request ${isCreate ? "created" : "saved"}`);
      } else {
        await drawRequestsService.updatePaymentForm(isCreate, id || "", payload.paymentForm, data);
        message.success(`Draw request ${isCreate ? "updated" : "saved"}`);
      }
      navigate("/draw-requests");
    } catch (error) {
      message.error(
        `Ups: something was wrong ${
          isCreate ? (!isEdit ? "creating" : "updating") : "saving"
        } the draw request, please try again later or contact the support team`
      );
      console.error(error);
    }
    setIsLoading(false);
  };

  const onSubmitForm = async (isEdit?: boolean) => {
    setIsLoading(true);
    const payload = { ...payloadExternal };
    if (payload?.paymentForm) {
      if (accountName === drawRequestPreview?.initiator && !isEdit) payload.paymentForm.initiatorSignature = signature;
      payload.paymentForm.id = drawRequestState?.paymentForm?.id;
    }

    payload.drawRequest = JSON.stringify(payload.drawRequest);
    payload.paymentForm = JSON.stringify(payload.paymentForm);

    setFinalPayload(payload);
    payloadExternal = payload;
    try {
      await drawRequestsService.updatePaymentForm(true, id || "", payload.paymentForm, {
        agreementDocID: payload.agreementDoc,
        invoiceCapitalCallDoc: payload.invoiceCapitalCallDoc,
        sanctionDoc: payload.sanctionDoc,
        achWireInstructions: payload.achWireInstructions,
        w9Form: payload.w9Form
      });

      message.success(`Draw request (with payment form) ${isEdit ? "updated" : "created"}`);
      navigate("/draw-requests");
    } catch (error) {
      message.error(
        `Ups: something was wrong ${isEdit ? "updating" : "creating"} the draw request, please try again later or contact the support team`
      );
      console.error(error);
    }
    setIsLoading(false);
  };

  const handleSecondForm = (isCreate: boolean, payload: any) => {
    setFinalPayload(payload);
    payloadExternal = payload;
    const drawRequest = {
      paymentMethod: form1.getFieldValue("paymentMethod"),
      initiator: form1.getFieldValue("initiator"),
      projectID: form1.getFieldValue("projectID"),
      accountID: form1.getFieldValue("accountID"),
      drawNumber: form1.getFieldValue("drawNumber"),
      amount: form1.getFieldValue("amount"),
      dueDate: form1.getFieldValue("dueDate"),
      invoiceDate: form1.getFieldValue("invoiceDate"),
      MainCmsGlCodeID: form1.getFieldValue("MainCmsGlCodeID"),
      drawType: form1.getFieldValue("drawType"),
      controlNumber: form1.getFieldValue("controlNumber")
    };

    setDrawRequestPreview({
      amount: drawRequest.amount,
      drawInvoice: drawRequest.drawNumber,
      dueDate: turnDate(drawRequest.dueDate),
      invoiceDate: turnDate(drawRequest.invoiceDate),
      initiator: drawRequest.initiator,
      paymentMethod: drawRequest.paymentMethod,
      Project: projects.find((project) => project.id === drawRequest.projectID)?.name || "",
      glCode: drawRequest.MainCmsGlCodeID,
      memos: [],
      controlNumber: drawRequest.controlNumber
      // jvDeposit: drawRequest.JvDepositGlCodeID,
      // jvWithdrawal: drawRequest.JvWithdrawalGlCodeID
    });

    const paymentForm: PaymentPreviewInterface = payload.paymentForm;

    setPaymentPreview({
      ...paymentForm,
      approvers
    });
    if (isCreate) setStep(3);
    else {
      onCreateAllDrawRequest(false);
    }
  };

  /*============================ END OF SECTION ============================*/

  return (
    <Spin spinning={isLoading} tip="loading ..." size="large">
      <div className="draw-request-new">
        {/* /========================================================================  HTML here
    ========================================================================*/}
        {/* /**======================
         *    Step 1
         *========================**/}
        {step === 1 && (
          <div className="stepOneContainer">
            <FirstForm
              isDistribution={isDistribution}
              setIsDistribution={setIsDistribution}
              createdDrawRequest={createdDrawRequest}
              setCreatedDrawRequest={setCreatedDrawRequest}
              handleCancel={handleCancel}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isEdit={isEdit}
              isCopy={isCopy}
              form={form1}
              form2={form2}
              setStep={setStep}
            ></FirstForm>
          </div>
        )}
        {/* /**======================
         *    End step 1
         *========================**/}
        {/* /**======================
         *    Step 2
         *========================**/}
        {step === 2 && (
          <div className="stepTwoContainer">
            <SecondForm
              handleCancel={handleCancel}
              approvers={approvers}
              setApprovers={setApprovers}
              amounts={amounts}
              setAmounts={setAmounts}
              isLoading={isLoading}
              isEdit={isEdit}
              isCopy={isCopy}
              form={form2}
              form1={form1}
              setStep={setStep}
              handleSecondForm={handleSecondForm}
              drawRequestState={drawRequestState}
            ></SecondForm>
          </div>
        )}
        {/* /**======================
         *    End Step 2
         *========================**/}
        {/* /**======================
         *    Step 3
         *========================**/}
        {step === 3 && (
          <div className="stepThreeContainer">
            <Row>
              <Col>
                <h2>Step 3: Review</h2>
              </Col>
            </Row>
            <hr style={{ marginBottom: "20px" }} />
            <DrawRequestPreview
              setIsLoading={setIsLoading}
              paymentPreview={paymentPreview}
              drawRequestPreview={drawRequestPreview}
            ></DrawRequestPreview>
            <div className="form-container-centered">
              <Row style={{ width: "80%" }}>
                <Col span={24}>
                  <Row style={{ marginTop: "33px" }}>
                    <Col style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                      <Button key="cancel" onClick={() => handleCancel()} danger type="primary">
                        Cancel
                      </Button>

                      <Button
                        key="back"
                        onClick={() => {
                          setStep(2);
                        }}
                      >
                        Back
                      </Button>

                      <Button
                        key="submit"
                        htmlType="submit"
                        type="primary"
                        onClick={() => {
                          if (!isEdit || isCopy) setSignatureModal(true);
                          else {
                            if (accountName === drawRequestPreview?.initiator) setSignatureModal(true);
                            else onSubmitForm(true);
                          }
                        }}
                      >
                        {isEdit && !isCopy ? "Save" : "Submit"}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        )}
        {/* /**======================
         *    End Step 2
         *========================**/}
        <SignatureModal
          currentSignature={signature && signature !== "data:image/png;base64," ? signature : ""}
          visible={signatureModal}
          setVisible={setSignatureModal}
          onSubmitSignature={onSubmitSignature}
        ></SignatureModal>
        {/*============================ END OF SECTION ============================*/}
      </div>
    </Spin>
  );
};
